import styles from './Placements.module.scss';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import { ButtonType, Card, CardSize, CardType } from '../Card';
import { SwiperButton } from '../SliderBlock';
import { useState } from 'react';
import { Palettes, Placement, Variants } from '@/types';
import { Button } from '../Button';
import { useShowMore } from '@/hooks/useShowMore';
import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';
import { useTranslations } from '@/hooks/useTranslations';

type PlacementsProps = {
  items: Placement[];
};

export function Placements({ items }: PlacementsProps) {
  const { isMobile } = useAdaptiveWidth();
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const numberOfShown = isMobile ? 5 : 100;
  const {
    getMore,
    items: posts,
    allShown,
  } = useShowMore(items, numberOfShown, 'placements');
  const translations = useTranslations();

  const handleSlideChange = (swiper: SwiperClass) => {
    setIsStart(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  if (isMobile)
    return (
      <div className={styles.grid}>
        <div className={styles.header}>
          <h3 className={styles.title}>{translations.placement}</h3>
        </div>
        <div className={styles.gridContent}>
          {posts.map((item, index) => (
            <Card
              key={`${item.name}-${index}`}
              picture={item.picture}
              link={`/places/${item.code}`}
              name={item.name}
              size={isMobile ? CardSize.XS : CardSize.SM}
              cardType={CardType.Filled}
              buttonType={item.big ? ButtonType.Arrow : ButtonType.Text}
              className={item.big ? styles.long : ''}
              pageMissing={item.pageMissing}
            />
          ))}
        </div>
        {!allShown && items.length > numberOfShown && (
          <Button
            text={translations.showMore}
            onClick={getMore}
            variant={Variants.Outline}
            palette={Palettes.Secondary}
            className={styles.more}
          />
        )}
      </div>
    );

  return (
    <Swiper
      slidesPerView="auto"
      spaceBetween={16}
      className={styles.slider}
      freeMode
      modules={[FreeMode]}
      onSlideChange={handleSlideChange}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{translations.placement}</h3>
        {!isMobile && items.length > 4 && (
          <div className={styles.buttons}>
            <SwiperButton disabled={isStart} />
            <SwiperButton disabled={isEnd} isNextButton />
          </div>
        )}
      </div>
      {items.map((item, index) => (
        <SwiperSlide key={`${item.name}-${index}`} className="custom-slide">
          <Card
            picture={item.picture}
            link={`/places/${item.code}`}
            name={item.name}
            size={CardSize.SM}
            cardType={CardType.Filled}
            buttonType={item.big ? ButtonType.Arrow : ButtonType.Text}
            className={item.big ? styles.long : ''}
            pageMissing={item.pageMissing}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
